import { __module as distanceTo } from '../../../../../_virtual/distance-to.js';

var hasRequiredDistanceTo;

function requireDistanceTo () {
	if (hasRequiredDistanceTo) return distanceTo.exports;
	hasRequiredDistanceTo = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = distanceTo;
		/**
		 * Calculate the distance between pointA and pointB
		 * @ignore
		 * @param {Point} pointA
		 * @param {Point} pointB
		 * @return {number} Distance
		 */
		function distanceTo(pointA, pointB) {
		  var xDiff = Math.pow(pointB.x - pointA.x, 2);
		  var yDiff = Math.pow(pointB.y - pointA.y, 2);

		  return Math.sqrt(xDiff + yDiff);
		}
		module.exports = exports["default"];
		
	} (distanceTo, distanceTo.exports));
	return distanceTo.exports;
}

export { requireDistanceTo as __require };
